export enum ScreenNames {
  LOGIN_HOME_PAGE = 'login_home_page',
  HOME = 'home',
  ONBOARDING = 'onboarding',
  ONBOARDING_PERSONAL_DETAILS = 'onboarding-personal-details',
  ONBOARDING_BANK_DETAILS = 'onboarding-bank-details',
  ONBOARDING_PAN_DETAILS = 'onboarding-pan-details',
  PROFILE = 'profile',
  PROFILE_PERSONAL_DETAILS_EDIT = 'profile-personal-details-edit',
  PROFILE_PAN_EDIT = 'profile-pan-edit',
  PROFILE_BANK_EDIT = 'profile-bank-edit',
  EARNINGS = 'earnings',
  REFERRALS = 'referrals',
  REFERRAL_DETAILS = 'referral-details',
  CITY_BONUS = 'city-bonus',
  FAQ = 'faq',
  HELP = 'help',
  LOGIN = 'login',
}

export enum EventNames {
  LOGIN = 'login',
  LOGOUT = 'logout',
  REFERRAL_SHARE = 'referral-share',
  REFERRAL_COPY = 'referral-copy',
  PROFILE_UPDATE = 'profile-update',
}

export enum UI_EVENT_TYPE {
  IMPRESSION = 'impression',
  CLICK = 'click',
  SCREENVIEW = 'screenview'
}

export enum EventField {
  USER_ID = 'user_id', // User ID (Influencer ID)
  ET = 'et', // Event type
  ON = 'on', // Object name
  OV = 'ov', // Object value
  SN = 'sn', // Screen name
  SI = 'si', // Sequence ID
  TS = 'ts', // Timestamp
  US = 'us', // User SID
  F1 = 'f1', // F1 value
  F2 = 'f2', // F2 value
  F3 = 'f3', // F3 value
  F4 = 'f4', // F4 value
  F5 = 'f5', // F5 value
  F6 = 'f6', // F6 value
  F7 = 'f7', // F7 value
  F8 = 'f8', // F8 value
  SOURCE = 'source', // Source value
  UA = 'ua', // User Agent
  AV = 'av', // App version code
}

export type EventNullProps = string | null | undefined;

export type SendEvent = {
  [K in EventField]?: string;
};

export const RouteToAnalyticsScreenMap: Record<string, string> = {
  '/': ScreenNames.LOGIN_HOME_PAGE,
  '/home/': ScreenNames.HOME,
  '/onboarding/': ScreenNames.ONBOARDING,
  '/onboarding/personal-details/': ScreenNames.ONBOARDING_PERSONAL_DETAILS,
  '/onboarding/bank-details/': ScreenNames.ONBOARDING_BANK_DETAILS,
  '/onboarding/pan-details/': ScreenNames.ONBOARDING_PAN_DETAILS,
  '/profile/': ScreenNames.PROFILE,
  '/profile/personal-details-edit/': ScreenNames.PROFILE_PERSONAL_DETAILS_EDIT,
  '/profile/pan-edit/': ScreenNames.PROFILE_PAN_EDIT,
  '/profile/bank-edit/': ScreenNames.PROFILE_BANK_EDIT,
  '/earnings/': ScreenNames.EARNINGS,
  '/referrals/': ScreenNames.REFERRALS,
  '/city-bonus/': ScreenNames.CITY_BONUS,
  '/profile/faqs/': ScreenNames.FAQ,
  '/profile/help/': ScreenNames.HELP,
};

